// extracted by mini-css-extract-plugin
export default {"guideItem":"GuideItem_guideItem__vtUxD","imageBlock":"GuideItem_imageBlock__4qYKT","imageHover":"GuideItem_imageHover__QwlHG","descriptionBlock":"GuideItem_descriptionBlock__rC95w"};